import { useSelector } from 'react-redux';

import type { RootState } from '@app-types/index';

import { INBOX_ENABLED } from '../featureFlags';

/** Brand orgs message creators; creator orgs don't get an inbox in S1. Kept
 *  out of the module index so the sidebar/drawer don't pull the lazy page. */
export const useInboxAvailable = (): boolean => {
  const isBrand = useSelector(
    (s: RootState) => s?.SelectedOrganization?.type === 'brand',
  );
  return INBOX_ENABLED && isBrand;
};

export default useInboxAvailable;
